import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PurchasedProductsListHeader} from './components/header/PurchasedProductsListHeader'
import {PurchasedProductsTable} from './table/PurchasedProductsTable'
import { PurchasedProductEditModal } from './PurchasedProduct-edit-modal/PurchasedProductEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const PurchasedProductsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <PurchasedProductsListHeader />
        <PurchasedProductsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PurchasedProductEditModal />}
    </>
  )
}

const PurchasedProductsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PurchasedProductsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PurchasedProductsListWrapper}
